import clsx from 'clsx';

import {
  createWidgetForChildNode,
  ObjectPropertiesProps,
} from './ObjectProperties';

import styles from './objectWidget.module.scss';

export function TableFormatObjectProperties({
  node,
  options,
  editor,
}: ObjectPropertiesProps) {
  return (
    <div
      className="rje-object__properties"
      style={{ boxShadow: 'none', border: 0 }}
    >
      {node.children.map((child) => (
        <div
          key={child.id}
          className={clsx(styles['table-item'], {
            [styles['table-item--nested']]: child.type === 'object',
          })}
        >
          {createWidgetForChildNode(
            node,
            options,
            { ...child, options: { ...child.options, tableLayout: true } },
            editor
          )}
        </div>
      ))}
    </div>
  );
}
